import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { formatFechaHora, formatUsuarioDisplay } from '../../utils';

const VARIANTS = {
    aceptada: {
        title: 'Solicitud aceptada',
        icon: faCheck,
        accent: '#399256',
    },
    rechazada: {
        title: 'Solicitud rechazada',
        icon: faTimes,
        accent: '#c45c5c',
    },
};

const DecisionAtClienteBanner = ({ decision }) => {
    if (!decision) {
        return (
            <span
                className="d-block pb-4 mb-3"
                style={{
                    color: '#9e9e9e',
                    fontSize: '0.85rem',
                    borderBottom: '1px solid #dee2e6',
                }}
            >
                Sin información de la decisión de atención al cliente.
            </span>
        );
    }

    const variant =
        decision.tipo === 'aceptada'
            ? VARIANTS.aceptada
            : VARIANTS.rechazada;

    return (
        <div
            className="pb-4 mb-4"
            style={{ borderBottom: '1px solid #dee2e6' }}
        >
            <div className="d-flex align-items-start gap-4">
                <FontAwesomeIcon
                    icon={variant.icon}
                    style={{
                        color: variant.accent,
                        fontSize: '1.65rem',
                        marginTop: 4,
                        flexShrink: 0,
                    }}
                />
                <div className="d-flex flex-column min-w-0 flex-grow-1">
                    <span
                        style={{
                            fontSize: '1.25rem',
                            fontWeight: 600,
                            color: variant.accent,
                            lineHeight: 1.3,
                        }}
                    >
                        {variant.title}
                    </span>
                    <span
                        style={{
                            fontSize: '0.875rem',
                            color: '#6c757d',
                            marginTop: 8,
                        }}
                    >
                        {formatUsuarioDisplay(decision.usuario)}
                        {' · '}
                        {formatFechaHora(decision.fecha_hora)}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default DecisionAtClienteBanner;
